
import IconQuestion from '@components/icons/icon-tooltip-question.svg'
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

/*
    AlignmentTypes description:

    - default: desktop -> right, mobile -> bottom (used for oeamtc-field__label for example)
    - top: desktop -> right, mobile -> top (used for components at the bottom of the whole screen)

    Types with '-offset' at the end: small vertical offset for arrow in desktop view (needed for oeamtc-listitem)
 */
export type AlignmentType = 'default' | 'default-offset' | 'top-offset';

@Component({
  name: 'TooltipElement',
  components: {
    IconQuestion
  }
})
export default class TooltipElement extends Vue {
  @Prop({ default: 'default' })
  private alignment: AlignmentType;

  @Prop({ default: false })
  private inline: Boolean;
}
